import { useEvent } from "@/lib/event-context";
import { getEnabledModules, moduleRegistry } from "@/components/modules/registry";
import type { ModuleConfigMap, ModuleId } from "@/lib/event-schema";

export function EventOverview() {
  const event = useEvent();
  const enabled = getEnabledModules(event);

  return (
    <>
      {enabled.map(({ id, config }) => {
        const entry = moduleRegistry[id];
        const Component = entry.Public as React.ComponentType<{
          config: ModuleConfigMap[ModuleId];
          event: typeof event;
        }>;
        return <Component key={id} config={config} event={event} />;
      })}
    </>
  );
}
